import { render, staticRenderFns } from "./IncidentReportModal.vue?vue&type=template&id=f13c1c04&"
import script from "./IncidentReportModal.vue?vue&type=script&lang=js&"
export * from "./IncidentReportModal.vue?vue&type=script&lang=js&"
import style0 from "./IncidentReportModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports